<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-text>
                <v-container class="pa-0" v-if="!loading">
                    <v-alert :type="validType">
                        <h3>{{ getTitle() }}</h3>
                    </v-alert>
                    <p class="px-4 ma-0 dialog-message">{{ message }}</p>
                </v-container>
                <v-row
                    class="pa-10"
                    align-content="center"
                    justify="center"
                    v-else
                >
                    <v-col
                        class="subtitle-1 text-center"
                        cols="12"
                    >
                        Processando... Aguarde.
                    </v-col>
                    <v-col cols="8">
                        <v-progress-linear
                            color="primary"
                            indeterminate
                            rounded
                            height="12"
                        ></v-progress-linear>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions v-if="!loading">
                <v-spacer></v-spacer>
                <v-btn
                    :color="validType"
                    text
                    @click="closeDialog"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ResponseModal",

    props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
    },

    methods: {
        getTitle() {
            if (this.type === 'success') {
                return 'Sucesso!';
            }
            if (this.type === 'error') {
                return 'Falha!';
            }
            if (this.type === 'warning') {
                return 'Atenção!';
            }

            return this.title;
        },

        closeDialog() {
            this.$emit('close');
            this.$emit('update:showDialog', false);
        }
    },

    data: () => ({
        loading: false,
        validTypes: ['info', 'error', 'success', 'warning'],
        defaultType: 'info'
    }),

    mounted() {
        if (this.showDialog && !this.message) {
            this.loading = true;
        }
        if (this.message) {
            this.loading = false;
        }

    },

    computed: {
        validType () {
            return this.validTypes.includes(this.type) ? this.type : this.defaultType;
        }
    }
}
</script>

<style lang="scss" scoped>
.v-dialog .v-card__text {
    padding: 0 !important;
}

.v-dialog .v-alert {
    border-radius: 0 !important;
}

.v-dialog, .v-dialog .v-card__text {
    overflow: hidden !important;
}

.dialog-message {
    font-size: 0.875rem;
    font-weight: 500;
}
</style>
